module.exports = __webpack_public_path__ + "img/shu.3f389f3c.jpg";